import { useAttachmentsUploadManager } from '@components'

import { Modal, ModalProps } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useEInvoicingAddressForm } from '../../contexts/eInvoicingAddressFormContext'
import type { SendAsEInvoiceModalView } from '../../types/sendAsEInvoiceModalView'
import { SendAsEInvoiceModalBody } from './elements/SendAsEInvoiceModalBody'
import { SendAsEInvoiceModalFooter } from './elements/SendAsEInvoiceModalFooter'

interface SendAsEInvoiceModalComponentProps extends ModalProps {
  attachmentsEnabled: boolean
  isMissingCustomerEInvoicingAddress: boolean
  onBeforeSubmit?: () => void
  view: SendAsEInvoiceModalView
}

export const SendAsEInvoiceModalComponent = ({
  attachmentsEnabled,
  isMissingCustomerEInvoicingAddress,
  onBeforeSubmit,
  view,
  ...modalProps
}: SendAsEInvoiceModalComponentProps): ReactElement => {
  const { t } = useTranslation()
  const { isSubmitting } = useEInvoicingAddressForm()
  const { isDeleting: isAttachmentsDeleting, isUploading: isAttachmentsUploading } = useAttachmentsUploadManager()

  const isModalClosable = !isAttachmentsDeleting && !isAttachmentsUploading && !isSubmitting
  const modalTitle = t('external_invoices.send_as_e_invoice.modal.e_invoicing_address.header')

  return (
    <Modal {...modalProps} size="s" closable={isModalClosable}>
      <Modal.Header title={modalTitle} />
      <SendAsEInvoiceModalBody
        attachmentsEnabled={attachmentsEnabled}
        isMissingCustomerEInvoicingAddress={isMissingCustomerEInvoicingAddress}
      />
      <SendAsEInvoiceModalFooter attachmentsEnabled={attachmentsEnabled} onBeforeSubmit={onBeforeSubmit} view={view} />
    </Modal>
  )
}
